export type PluralFormsRu = readonly [one: string, few: string, many: string]

/**
 * Склонение существительного по числу (русский язык).
 * @param count — число, для которого подбирается форма
 * @param forms — [один, два–четыре, пять и более] (например ['токен', 'токена', 'токенов'])
 */
export const pluralizeRu = (count: number, forms: PluralFormsRu): string => {
    const abs = Math.abs(count) % 100
    const mod10 = abs % 10

    if (abs > 10 && abs < 20) {
        return forms[2]
    }
    if (mod10 === 1) {
        return forms[0]
    }
    if (mod10 >= 2 && mod10 <= 4) {
        return forms[1]
    }
    return forms[2]
}
